import { ChatMessage } from '../chat/chat.models';

export const MOCK_MESSAGES_BY_CONVERSATION_ID: Record<string, ChatMessage[]> = {
  'failed-empty': [
    {
      id: 'u1',
      role: 'user',
      content: 'List funds that exited via IPO in 2024-2025.',
    },
    {
      id: 'a1',
      role: 'assistant',
      label: 'Analysis',
      contentMarkdown: 'Request failed.',
      status: 'error',
      steps: [
        {
          key: 'call_19b60b5c7c7d:Analyze Query',
          stepId: 'call_19b60b5c7c7d',
          name: 'Analyze Query',
          description: 'List funds that exited via IPO in 2024\u20132025.',
          status: 'completed',
        },
      ],
    },
  ],
  fb804c5d513ffa09: [
    {
      id: 'u1',
      role: 'user',
      content: 'Give a breakdown summary why success % for the following data',
    },
    {
      id: 'a1',
      role: 'assistant',
      label: 'Analysis',
      tokenUsage: { totalTokens: 52631, inputTokens: 51288, outputTokens: 1343 },
      contentMarkdown: `The overall success percentage for the provided data is **very low**, at only **0.32%**.\n\n---\n\n## Overall and Daily Success Summary\n\n| Category | Successes | Total Attempts | Success Percentage |\n| --- | ---: | ---: | ---: |\n| Overall | 7,368 | 2,301,450 | 0.32% |\n\n### Notes\n- The low overall success rate is primarily driven by the massive volume of failures across a few major domains.\n- Investigate the highest-volume domains first.\n\n\`\`\`ts\n// Example: compute success percentage\nexport function pct(success: number, total: number) {\n  return total === 0 ? 0 : (success / total) * 100;\n}\n\`\`\`\n`,
    },
  ],
  'flight-options': [
    {
      id: 'u1',
      role: 'user',
      content: 'Find same-day flight options between Bengaluru and Visakhapatnam.',
    },
    {
      id: 'a1',
      role: 'assistant',
      label: 'Analysis',
      contentMarkdown:
        'Here are a few options you can try: **non-stop first**, then **1-stop**.\n\n- Check earliest departures.\n- Consider nearby airports.\n',
    },
  ],
  'health-tracker': [
    { id: 'u1', role: 'user', content: 'Track my health data.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your health data.' },
  ],
  'fitness-plan': [
    { id: 'u1', role: 'user', content: 'Create a fitness plan.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your fitness plan.' },
  ],
  'diet-plan': [
    { id: 'u1', role: 'user', content: 'Create a diet plan.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your diet plan.' },
  ],
  'sleep-tracker': [
    { id: 'u1', role: 'user', content: 'Track my sleep data.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your sleep data.' },
  ],
  'mood-tracker': [
    { id: 'u1', role: 'user', content: 'Track my mood data.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your mood data.' },
  ],
  'productivity-tracker': [
    { id: 'u1', role: 'user', content: 'Track my productivity data.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your productivity data.' },
  ],
  'finance-tracker': [
    { id: 'u1', role: 'user', content: 'Track my finance data.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your finance data.' },
  ],
  'travel-plan': [
    { id: 'u1', role: 'user', content: 'Create a travel plan.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your travel plan.' },
  ],
  'home-security': [
    { id: 'u1', role: 'user', content: 'Create a home security plan.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your home security plan.' },
  ],
  'home-automation': [
    { id: 'u1', role: 'user', content: 'Create a home automation plan.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your home automation plan.' },
  ],
  'home-security-2': [
    { id: 'u1', role: 'user', content: 'Create a home security plan.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your home security plan.' },
  ],
  'home-automation-2': [
    { id: 'u1', role: 'user', content: 'Create a home automation plan.' },
    { id: 'a1', role: 'assistant', contentMarkdown: 'Here is your home automation plan.' },
  ],
};
